import { ColorEnum } from '@enum/style/color.enum';

export const mainGuideStyle = {
  options: {
    zIndex: 10000,
    primaryColor: ColorEnum.Teal100,
  },
};
